<template>
  <div>
    <div class="card shadow">
      <a id="button"></a>
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t('message.add') }} {{ $t('message.cardiologyConsultations') }}
          </h3>
        </div>
      </div>

      <div class="card-body">

        <h3 class="text-center"> {{$t('message.infoConsultation')}}
        </h3>
        <b-form  @reset="onReset" v-if="show">
          <b-container>
            <b-row>
              <b-col sm="12">
                  <span class="obligatoire">*</span>
                  <b-form-group id="timeLine-group" :label="$tc('message.TimelineSelect', 2)" label-for="timeLine" >
                      <select id="timeLine" v-model="$v.form.ligne_de_temps_id.$model" class="form-control is-invalid retirerBordure" @change="clearErrorField('ligne_de_temps_id')" required>
                          <option data-placeholder="true"></option>
                          <option v-for="item in lignetempsRows" :key="item.id" :value="item.id">
                              {{item.motif}} <b-badge variant="info">{{item.date}}</b-badge>
                          </option>
                      </select>
                      <b-form-invalid-feedback v-if="$v.form.ligne_de_temps_id.$error">
                          {{ $t('message.requiredField') }}
                      </b-form-invalid-feedback>
                      <span v-if="errorshasField('ligne_de_temps_id')" style="color:red">
                          {{getErrorsField('ligne_de_temps_id')}}
                      </span>
                  </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>
                <b-form-group
                    id="institution-group"
                    :label="$t('message.institutionConsultation')"
                    label-for="institution"
                >
                  <select id="institution" v-model="$v.form.institution.$model"
                          @change="clearErrorField('etablissement_id')"
                          class="form-control is-invalid retirerBordure"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.institution.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <span  class="obligatoire">*</span>

                <b-form-group
                    id="consultation-group"
                    :label="$t('message.consultationDate')"
                    label-for="consultation"
                    description="">
                  <b-form-input
                      id="consultation"
                      v-model="$v.form.date_consultation.$model"
                      :state="$v.form.date_consultation.$dirty ? !(errorshasField('date_consultation') || $v.form.date_consultation.$error) : null"
                      type="date"
                      required
                      @focus="clearErrorField('date_consultation')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.date_consultation.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('date_consultation')">
                    {{ getErrorsField('date_consultation') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group
                    id="contributors-group"
                    :label="$tc('message.contributors',2)"
                    label-for="contributors"
                >
                  <select id="contributors" v-model="$v.form.contributors.$model"
                          @change="clearErrorField('contributeurs')"
                          class="form-control is-invalid retirerBordure"
                          required
                          multiple
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mContributors" :key="item.id" :value="item.id">
                      {{ item.nom }}
                    </option>
                  </select>
                  <span v-if="errorshasField('contributeurs')" style="color:red">
                                    {{getErrorsField('contributeurs')}}
                                    </span>
                </b-form-group>
              </b-col>

            </b-row>

            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="anamese-group"
                    :label="$t('message.anamnesis')"
                    label-for="anamese"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.anamese.$model"
                      :state="$v.form.anamese.$dirty ? !(errorshasField('anamese') || $v.form.anamese.$error) : null"
                      @focus="clearErrorField('anamese')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <b-form-invalid-feedback v-if="errorshasField('anamese')">
                    {{ getErrorsField('anamese') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-form-group
                    id="facteur-group"
                    :label="$t('message.riskFactor')"
                    label-for="singleMotif"
                >
                  <select id="facteur" v-model="$v.form.facteur_de_risque.$model" multiple
                          class="form-control is-invalid retirerBordure"
                          @change="clearErrorField('facteur_de_risque')"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in facteurs" :key="item" :value="item">
                      {{ item }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.facteur_de_risque.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('facteur_de_risque')" style="color:red">
                                    {{getErrorsField('facteur_de_risque')}}
                                    </span>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <span  class="obligatoire">*</span>

                <b-form-group
                    id="singleMotif-group"
                    :label="$tc('message.reasons', 2)"
                    label-for="singleMotif"
                >
                  <select id="singleMotif" v-model="$v.form.motifs.$model" multiple
                          class="form-control is-invalid retirerBordure"
                          @change="clearErrorField('motifs')"
                          required
                  >
                    <option data-placeholder="true"></option>
                    <option v-for="item in mReasons" :key="item.value" :value="item.value">
                      {{ item.text }}
                    </option>
                  </select>
                  <b-form-invalid-feedback v-if="$v.form.motifs.$error">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>
                  <span v-if="errorshasField('motifs')" style="color:red">
                                    {{getErrorsField('motifs')}}
                                    </span>
                </b-form-group>
              </b-col>

            </b-row>

            <!--                        Debut Antecedent-->

            <!--                        <b-row>-->
            <!--                            <b-col sm="12">-->
            <h3 class="text-center"> {{$t('message.infoAntecedents')}}
              <!--                            <a :href="pathTo('#formAntecedent')"> </a>-->
            </h3>
            <!--                        <a :href="pathTo('#antecedent')" @click="toggleAntecedent" v-if="antecedentsRows.length>0">{{$tc('message.antecedents',2)}}</a>-->

            <div id="antecedentForm">
              <b-card-body v-if="antecedentsRows.length>0">
                <vue-good-table
                    id="antecedent"
                    v-if="notEmpty(antecedentsRows)"
                    :columns="antecedentsColumns"
                    :rows="antecedentsRows"
                    :search-options="enabled"
                    :pagination-options="paginationOptions"
                    :groupOptions="enabled"
                    :sort-options="sort"
                    @on-row-click="onAntecedentRowClick"

                />
              </b-card-body>
              <div class="shadow " >
                <div class="container-perso" id="formAntecedent">
                  <b-form  @reset="onReset" v-if="show">
                    <b-container>
                      <b-row>
                        <b-col sm="12">
                          <span  class="obligatoire">*</span>

                          <b-form-group
                              id="type-group"
                              :label="$t('message.select')+' '+$tc('message.types',1)"
                              label-for="type"
                              class="mt-2"
                          >
                            <!-- Options -->
                            <select id="type"
                                    v-model="$v.antecedents.type.$model"
                                    class="form-control is-invalid retirerBordure"
                                    required
                                    :state="$v.antecedents.type.$dirty ? !(errorshasField('type') || $v.antecedents.type.$error) : null"
                                    @focus="clearErrorField('type')"
                            >
                              <option v-for="item in types" :value="item.value" :key="item.value">
                                {{ item.text }}
                              </option>
                            </select>

                            <b-form-invalid-feedback v-if="$v.antecedents.type.$error">
                              {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="errorshasField('type')">
                              {{ getErrorsField('type') }}
                            </b-form-invalid-feedback>

                          </b-form-group>
                        </b-col>
                        <b-col sm="12">

                          <b-form-group
                              id="date-group"
                              :label="$t('message.startDate')"
                              label-for="date"
                          >
                            <b-form-input
                                id="date"
                                v-model="$v.antecedents.date.$model"
                                :state="$v.antecedents.date.$dirty ? !(errorshasField('date') || $v.allergiesForm.date.$error) : null"
                                type="date"
                                required
                                @click="clearErrorField('date')"
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="$v.antecedents.date.$error">
                              {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                            <span v-if="errorshasField('date')" style="color:red">
                                    {{getErrorsField('date')}}
                                    </span>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12">
                          <span  class="obligatoire">*</span>

                          <b-form-group
                              id="description-group"
                              :label="$t('message.description')"
                              label-for="description"
                          >
                            <b-form-textarea
                                id="description"
                                v-model="$v.antecedents.description.$model"
                                :state="$v.antecedents.description.$dirty ? !(errorshasField('description') || $v.antecedents.description.$error) : null"
                                required
                                @focus="errorshasField('description')"
                            ></b-form-textarea>
                            <b-form-invalid-feedback v-if="!$v.antecedents.description.required">
                              {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                            <b-form-invalid-feedback v-if="!$v.antecedents.description.minLength">
                              {{ $t('message.minCharacters', { n: 3 }) }}
                            </b-form-invalid-feedback>
                            <b-form-invalid-feedback v-if="errorshasField('description')">
                              {{ getErrorsField('description') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <b-col sm="1">
                        </b-col>
                      </b-row>
                      <b-row class="justify-content-sm-center mb-2" v-if="can">
                        <b-button @click="onAntecedentSubmit" variant="primary">
                          {{ $t('message.save') }}
                        </b-button>
                        <!--                                                <a href="#retourConsultation" class="pt-2"> <i class="fas fa-angle-double-up"></i>  {{$t('message.back')}}</a>-->

                      </b-row>
                    </b-container>
                  </b-form>
                </div>
              </div>
            </div>
            <!--                            </b-col>-->

            <!--                        //Fin Antecedent-->

            <!--                        //Debut Allergie-->
            <!--                            <b-col sm="12">-->
            <h3 class="text-center"> {{$t('message.infoAllergies')}}
              <!--                            <a :href="pathTo('#formAllergie')"> </a>-->
            </h3>
            <!--                        <a :href="pathTo('#allergie')" @click="toggleAllergie" v-if="allergiesRows.length>0">{{$tc('message.allergies',2)}}</a>-->

            <div id="allergieForm">
              <b-card-body v-if=" allergiesRows.length>0">
                <vue-good-table
                    id="allergie"
                    v-if="notEmpty(allergiesRows)"
                    :columns="allergiesColumns"
                    :rows="allergiesRows"
                    :search-options="enabled"
                    :pagination-options="paginationOptions"
                    @on-row-click="onAllergieRowClick"
                />
              </b-card-body>
              <div class="shadow" >
                <div class="container-perso" id="formAllergie">
                  <b-form  @reset="onReset" v-if="show">
                    <b-container>
                      <b-row>
                        <b-col sm="12">
                          <span  class="obligatoire">*</span>

                          <b-form-group
                              id="type-group"
                              :label="$t('message.add')+' '+$tc('message.description',1)"
                              label-for="type"
                              class="mt-2"

                          >
                            <!-- Options -->
                            <select id="allergies"
                                    v-model="$v.allergiesForm.description.$model"
                                    required
                                    class="form-control is-invalid retirerBordure"
                                    :state="$v.allergiesForm.description.$dirty ? !(errorshasField('type') || $v.allergiesForm.description.$error) : null"
                                    @focus="clearErrorField('type')"
                                    multiple
                            >
                              <option data-placeholder="true"></option>
                              <option v-for="item in descriptions" :value="item.value" :key="item.value">
                                {{ item.text }}
                              </option>
                            </select>

                            <b-form-invalid-feedback v-if="$v.allergiesForm.description.$error">
                              {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="errorshasField('description')">
                              {{ getErrorsField('description') }}
                            </b-form-invalid-feedback>

                          </b-form-group>
                        </b-col>
                        <!--                                    <b-col sm="12">-->

                        <!--                                        <b-form-group-->
                        <!--                                                id="date-group"-->
                        <!--                                                :label="$t('message.startDate')"-->
                        <!--                                                label-for="date"-->
                        <!--                                        >-->
                        <!--                                            <b-form-input-->
                        <!--                                                    id="date"-->
                        <!--                                                    v-model="$v.allergiesForm.date.$model"-->
                        <!--                                                    :state="$v.allergiesForm.date.$dirty ? !(errorshasField('date') || $v.allergiesForm.date.$error) : null"-->
                        <!--                                                    type="date"-->
                        <!--                                                    @click="clearErrorField('date')"-->
                        <!--                                            ></b-form-input>-->

                        <!--                                            <b-form-invalid-feedback>-->
                        <!--                                                {{ $t('message.requiredField') }}-->
                        <!--                                            </b-form-invalid-feedback>-->
                        <!--                                            <span v-if="errorshasField('date')" style="color:red">-->
                        <!--                                    {{getErrorsField('date')}}-->
                        <!--                                    </span>-->
                        <!--                                        </b-form-group>-->
                        <!--                                    </b-col>-->
                      </b-row>
                      <b-row class="justify-content-sm-center mb-2" v-if="can">
                        <b-button @click="onAllergieSubmit" variant="primary">
                          {{ $t('message.save') }}
                        </b-button>

                        <!--                                                <a href="#retourConsultation" class="pt-2"> <i class="fas fa-angle-double-up"></i> {{$t('message.back')}}</a>-->

                      </b-row>
                    </b-container>
                  </b-form>
                </div></div>
            </div>
            <!--                            </b-col>-->
            <!--                        </b-row>-->
            <!--                        //Fin Allergie-->

            <!--                        //Debut Traitement Actuel-->
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="traitementsACreer-group"
                    :label="$t('message.currentTreatments')"
                    label-for="traitementsACreer">
                  <b-form-textarea
                      id="traitementsACreer"
                      v-model="$v.form.traitements.$model"
                      :state="$v.form.traitements.$dirty ? !(errorshasField('traitements') || $v.form.traitements.$error) : null"
                      placeholder=""
                      @focus="clearErrorField('anamese')"
                  ></b-form-textarea>
                  <b-form-invalid-feedback v-if="errorshasField('traitements')">
                    {{getErrorsField('traitements')}}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="occupation-group"
                    :label="$t('message.profession')"
                    label-for="occupation-propose"
                >
                  <b-form-input
                      id="occupation"
                      v-model="$v.form.profession.$model"
                      :state="$v.form.profession.$dirty ? !(errorshasField('profession') || $v.form.profession.$error) : null"
                      @focus="clearErrorField('profession')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="errorshasField('profession')">
                    {{ getErrorsField('profession') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-form-group :label="$t('message.familyStuation')">
                  <b-form-radio-group id="situation_familiale" v-model="$v.form.situation_familiale.$model" name="situation_familiale">
                    <b-form-radio   value="Marié(e)">{{$t('message.marie')}}</b-form-radio>
                    <b-form-radio   value="Celibataire">{{$t('message.celibataire')}}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>

              <b-col sm="12">
                <b-col sm="2">
                  <div>
                    <label class="form__label" for="hasDesc">{{$t('message.tabac')}}</label>
                    <div class="toggle">
                      <input id="hasDesc2" type="checkbox" v-model="smoke"/>
                      <label for="hasDesc2">
                        <div class="toggle__switch"></div>
                      </label>
                    </div>
                  </div>
                </b-col>

                <div v-if="smoke" :class="{ 'form-group--error': $v.form.tabac.$error}">
                  <b-col sm="5">
                    <span  class="obligatoire">*</span>

                    <b-form-group
                        id="tabac-group"
                        :label="$t('message.smokedPerDay')"
                        label-for="tabac"
                    >
                      <b-form-input
                          id="tabac"
                          v-model="$v.form.nbreParJour.$model"
                          :state="$v.form.nbreParJour.$dirty ? !(errorshasField('tabac') || $v.form.nbreParJour.$error) : null"
                          type="text"
                          required
                          placeholder=""
                          @focus="clearErrorField('tabac')"
                      ></b-form-input>

                      <b-form-invalid-feedback v-if="!$v.form.tabac.required">
                        {{ $t('message.requiredField') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col sm="5">
                    <span  class="obligatoire">*</span>
                    <b-form-group
                        id="tabac2-group"
                        :label="$t('message.numberOfYear')"
                        label-for="tabac2"
                    >
                      <b-form-input
                          id="tabac2"
                          v-model="$v.form.nbreAnnee.$model"
                          :state="$v.form.nbreAnnee.$dirty ? !(errorshasField('tabac') || $v.form.nbreAnnee.$error) : null"
                          type="text"
                          required
                          placeholder=""
                          @focus="clearErrorField('tabac')"
                      ></b-form-input>

                      <b-form-invalid-feedback v-if="!$v.form.nbreAnnee.required">
                        {{ $t('message.requiredField') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </div>
              </b-col>

              <b-col sm="12">
                <b-col sm="2">
                  <div>
                    <label class="form__label" for="hasDesc">{{$t('message.alcool')}}</label>
                    <div class="toggle">
                      <input id="hasDesc3" type="checkbox" v-model="drink"/>
                      <label for="hasDesc3">
                        <div class="toggle__switch"></div>
                      </label>
                    </div>
                  </div>
                </b-col>
                <b-col sm="5">
                  <div v-if="drink" :class="{ 'form-group--error': $v.form.alcool.$error}">
                    <span  class="obligatoire">*</span>

                    <b-form-group
                        id="alcool-group"
                        :label="$t('message.value')"
                        label-for="alcool"
                    >
                      <b-form-input
                          id="alcool"
                          v-model="$v.form.alcool.$model"
                          :state="$v.form.alcool.$dirty ? !(errorshasField('alcool') || $v.form.alcool.$error) : null"
                          type="text"
                          required
                          placeholder=""
                          @focus="clearErrorField('alcool')"
                      ></b-form-input>

                      <b-form-invalid-feedback v-if="!$v.form.alcool.required">
                        {{ $t('message.requiredField') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </b-col>
              </b-col>

              <b-col sm="12">
                <b-col sm="2">
                  <div>
                    <label class="form__label" for="hasDesc">{{$tc('message.enfants',1)}}</label>
                    <div class="toggle">
                      <input id="hasDesc" type="checkbox" v-model="hasChild"/>
                      <label for="hasDesc">
                        <div class="toggle__switch"></div>
                      </label>
                    </div>
                  </div>
                </b-col>
                <b-col sm="5">
                  <div v-if="hasChild" :class="{ 'form-group--error': $v.form.nbre_enfant.$error}">
                    <span  class="obligatoire">*</span>

                    <b-form-group
                        id="email-group"
                        :label="$t('message.nombreEnfant')"
                        label-for="email"
                    >
                      <b-form-input
                          id="email"
                          v-model="$v.form.nbre_enfant.$model"
                          :state="$v.form.nbre_enfant.$dirty ? !(errorshasField('nbre_enfant') || $v.form.nbre_enfant.$error) : null"
                          type="text"
                          required
                          placeholder=""
                          @focus="clearErrorField('nbre_enfant')"
                      ></b-form-input>

                      <b-form-invalid-feedback v-if="!$v.form.nbre_enfant.required">
                        {{ $t('message.requiredField') }}
                      </b-form-invalid-feedback>

                      <b-form-invalid-feedback v-else-if="!$v.form.nbre_enfant.email">
                        {{ $t('message.emailNotValid') }}
                      </b-form-invalid-feedback>

                      <b-form-invalid-feedback v-else-if="errorshasField('email')">
                        {{ getErrorsField('email') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </b-col>
              </b-col>

              <!--                            <b-col sm="12">-->
              <!--                                <b-form-group-->
              <!--                                        id="autres-group"-->
              <!--                                        :label="$t('message.autres')"-->
              <!--                                        label-for="autres"-->
              <!--                                >-->
              <!--                                    <editor-->
              <!--                                            :api-key="tinyKey"-->
              <!--                                            id="autres"-->
              <!--                                            v-model="$v.form.autres.$model"-->
              <!--                                            :state="$v.form.autres.$dirty ? !(errorshasField('autres') || $v.form.autres.$error) : null"-->
              <!--                                            @focus="clearErrorField('autres')"-->
              <!--                                            :init="{-->
              <!--                                              height: 200,-->
              <!--                                              menubar: false,-->
              <!--                                              plugins: plugins,-->
              <!--                                              toolbar:toolbar-->
              <!--                                            }"-->
              <!--                                    >-->
              <!--                                    </editor>-->
              <!--                                    &lt;!&ndash;                                    <b-form-textarea&ndash;&gt;-->
              <!--                                    &lt;!&ndash;                                            id="autres"&ndash;&gt;-->
              <!--                                    &lt;!&ndash;                                            v-model="$v.form.autres.$model"&ndash;&gt;-->
              <!--                                    &lt;!&ndash;                                            :state="$v.form.autres.$dirty ? !(errorshasField('autres') || $v.form.autres.$error) : null"&ndash;&gt;-->
              <!--                                    &lt;!&ndash;                                            @focus="clearErrorField('autres')"&ndash;&gt;-->
              <!--                                    &lt;!&ndash;                                            row="1"&ndash;&gt;-->
              <!--                                    &lt;!&ndash;                                    ></b-form-textarea>&ndash;&gt;-->

              <!--                                    <b-form-invalid-feedback v-if="errorshasField('autres')">-->
              <!--                                        {{ getErrorsField('autres') }}-->
              <!--                                    </b-form-invalid-feedback>-->
              <!--                                </b-form-group>-->
              <!--                            </b-col>-->
            </b-row>

            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="clinique-group"
                    :label="$tc('message.physicalExams', 1)"
                    label-for="clinique"
                >
                  <editor
                      :api-key="tinyKey"
                      initialValue=""
                      v-model="$v.form.examen_clinique.$model"
                      :state="$v.form.examen_clinique.$dirty ? !(errorshasField('examen_clinique') || $v.form.examen_clinique.$error) : null"
                      @focus="clearErrorField('examen_clinique')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>
                  <!--                                    <b-form-textarea-->
                  <!--                                            id="clinique"-->
                  <!--                                            v-model="$v.form.examen_clinique.$model"-->
                  <!--                                            :state="$v.form.examen_clinique.$dirty ? !(errorshasField('examen_clinique') || $v.form.examen_clinique.$error) : null"-->
                  <!--                                            rows="5"-->
                  <!--                                            @focus="clearErrorField('examen_clinique')"-->
                  <!--                                    ></b-form-textarea>-->

                  <b-form-invalid-feedback v-if="errorshasField('examen_clinique')">
                    {{ getErrorsField('examen_clinique') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12">

                <b-form-group
                    id="poids-group"
                    :label="$t('message.weight')"
                    label-for="poids"
                >
                  <b-form-input
                      id="reference"
                      v-model="$v.form.poids.$model"
                      :state="$v.form.poids.$dirty ? !(errorshasField('poids') || $v.form.poids.$error) : null"
                      @focus="clearErrorField('poids')"
                      type="number"
                      step="0.01"

                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.poids.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-if="errorshasField('poids')">
                    {{ getErrorsField('poids') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">

                <b-form-group
                    id="taille-group"
                    :label="$t('message.height')"
                    label-for="taille"
                >
                  <b-form-input
                      id="taille"
                      v-model="$v.form.taille.$model"
                      :state="$v.form.taille.$dirty ? !(errorshasField('taille') || $v.form.taille.$error) : null"
                      @focus="clearErrorField('taille')"
                      type="number"
                      step="0.01"
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="!$v.form.taille.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('taille')">
                    {{ getErrorsField('taille') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">

                <b-form-group
                    id="perimerte-group"
                    :label="$t('message.abdoPerimetre')"
                    label-for="perimerte"
                >
                  <b-form-input
                      id="perimerte"
                      v-model="$v.form.perimetre_abdominal.$model"
                      :state="$v.form.perimetre_abdominal.$dirty ? !(errorshasField('perimetre_abdominal') || $v.form.perimetre_abdominal.$error) : null"
                      @focus="clearErrorField('perimetre_abdominal')"
                      type="number"
                      step="0.01"
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="!$v.form.perimetre_abdominal.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('perimetre_abdominal')">
                    {{ getErrorsField('perimetre_abdominal') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">

                <b-form-group
                    id="temperature-group"
                    :label="$t('message.temperature')"
                    label-for="temperature"
                >
                  <b-form-input
                      id="temperature"
                      v-model="$v.form.temperature.$model"
                      :state="$v.form.temperature.$dirty ? !(errorshasField('temperature') || $v.form.temperature.$error) : null"
                      @focus="clearErrorField('temperature')"
                      type="number"
                      step="0.01"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.temperature.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('temperature')">
                    {{ getErrorsField('temperature') }}
                  </b-form-invalid-feedback>
                </b-form-group>

              </b-col>

            </b-row>

            <b-row>

              <b-col sm="12">

                <b-form-group
                    id="ta_systolique-group"
                    :label="$t('message.taSystoliqueL')"
                    label-for="ta_systolique"
                >
                  <b-form-input
                      id="ta_systolique"
                      v-model="$v.form.ta_systolique.$model"
                      :state="$v.form.ta_systolique.$dirty ? !(errorshasField('ta_systolique') || $v.form.ta_systolique.$error) : null"
                      @focus="clearErrorField('ta_systolique')"
                      type="number"
                      step="0.01"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.ta_systolique.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('ta_systolique')">
                    {{ getErrorsField('ta_systolique') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">

                <b-form-group
                    id="ta_diastolique-group"
                    :label="$t('message.taDiastoliqueL')"
                    label-for="ta_diastolique"
                >
                  <b-form-input
                      id="ta_diastolique"
                      v-model="$v.form.ta_diastolique.$model"
                      :state="$v.form.ta_diastolique.$dirty ? !(errorshasField('ta_diastolique') || $v.form.ta_diastolique.$error) : null"
                      @focus="clearErrorField('ta_diastolique')"
                      type="number"
                      step="0.01"
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="!$v.form.ta_diastolique.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('ta_diastolique')">
                    {{ getErrorsField('ta_diastolique') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">

                <b-form-group
                    id="ta_systolique_d-group"
                    :label="$t('message.taSystoliqueD')"
                    label-for="ta_systolique"
                >
                  <b-form-input
                      id="ta_systolique_d"
                      v-model="$v.form.ta_systolique_d.$model"
                      :state="$v.form.ta_systolique_d.$dirty ? !(errorshasField('ta_systolique_d') || $v.form.ta_systolique_d.$error) : null"
                      @focus="clearErrorField('ta_systolique_d')"
                      type="number"
                      step="0.01"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.ta_systolique_d.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('ta_systolique_d')">
                    {{ getErrorsField('ta_systolique_d') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">

                <b-form-group
                    id="ta_diastolique_d-group"
                    :label="$t('message.taDiastoliqueD')"
                    label-for="ta_diastolique"
                >
                  <b-form-input
                      id="ta_diastolique_d"
                      v-model="$v.form.ta_diastolique_d.$model"
                      :state="$v.form.ta_diastolique_d.$dirty ? !(errorshasField('ta_diastolique_d') || $v.form.ta_diastolique_d.$error) : null"
                      @focus="clearErrorField('ta_diastolique_d')"
                      type="number"
                      step="0.01"
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="!$v.form.ta_diastolique_d.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('ta_diastolique_d')">
                    {{ getErrorsField('ta_diastolique_d') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="12">

                <b-form-group
                    id="frequence_cardiaque-group"
                    :label="$t('message.heartRate')"
                    label-for="frequence_cardiaque"
                >
                  <b-form-input
                      id="frequence_cardiaque"
                      v-model="$v.form.frequence_cardiaque.$model"
                      :state="$v.form.frequence_cardiaque.$dirty ? !(errorshasField('frequence_cardiaque') || $v.form.frequence_cardiaque.$error) : null"
                      @focus="clearErrorField('frequence_cardiaque')"
                      type="number"
                      step="0.01"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.frequence_cardiaque.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('frequence_cardiaque')">
                    {{ getErrorsField('frequence_cardiaque') }}
                  </b-form-invalid-feedback>
                </b-form-group>

              </b-col>

            </b-row>

            <b-row>

              <b-col sm="12">

                <b-form-group
                    id="frequence_respiratoire-group"
                    :label="$t('message.respiratoryRate')"
                    label-for="frequence_respiratoire"
                >
                  <b-form-input
                      id="frequence_respiratoire"
                      v-model="$v.form.frequence_respiratoire.$model"
                      :state="$v.form.frequence_respiratoire.$dirty ? !(errorshasField('frequence_respiratoire') || $v.form.frequence_respiratoire.$error) : null"
                      @focus="clearErrorField('frequence_respiratoire')"
                      type="number"
                      step="0.01"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.frequence_respiratoire.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('frequence_respiratoire')">
                    {{ getErrorsField('frequence_respiratoire') }}
                  </b-form-invalid-feedback>
                </b-form-group>

              </b-col>

              <b-col sm="12">

                <b-form-group
                    id="sato2-group"
                    :label="$t('message.sato2')"
                    label-for="sato2"
                >
                  <b-form-input
                      id="sato2"
                      v-model="$v.form.sato2.$model"
                      :state="$v.form.sato2.$dirty ? !(errorshasField('sato2') || $v.form.sato2.$error) : null"
                      @focus="clearErrorField('sato2')"
                      type="number"
                      step="0.01"
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="!$v.form.sato2.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('sato2')">
                    {{ getErrorsField('sato2') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <!--                        On va mettre les examens cardio ici-->
            <h3 class="text-center"> {{$t('message.cardiacExam')}}
              <!--                            <a :href="pathTo('#formAntecedent')"> </a>-->
            </h3>
            <!--                        <a :href="pathTo('#antecedent')" @click="toggleAntecedent" v-if="antecedentsRows.length>0">{{$tc('message.antecedents',2)}}</a>-->

            <div id="cardiacExamForm">
              <!--                            <b-card-body v-if="antecedentsRows.length>0">-->
              <!--                                <vue-good-table-->
              <!--                                        id="exanenCardiaque"-->
              <!--                                        v-if="notEmpty(antecedentsRows)"-->
              <!--                                        :columns="antecedentsColumns"-->
              <!--                                        :rows="antecedentsRows"-->
              <!--                                        :search-options="enabled"-->
              <!--                                        :pagination-options="paginationOptions"-->
              <!--                                        :groupOptions="enabled"-->
              <!--                                        :sort-options="sort"-->
              <!--                                        @on-row-click="onAntecedentRowClick"-->

              <!--                                />-->
              <!--                            </b-card-body>-->
              <div class="shadow " >
                <div class="container-perso" id="formExamenCardiaque">
                  <b-form  @reset="onReset" v-if="show">
                    <b-container>
                      <b-row>
                        <b-col sm="12">
                          <span  class="obligatoire">*</span>

                          <b-form-group
                              id="name-group"
                              :label="$t('message.select')+' '+$t('message.name')"
                              label-for="name"
                              class="mt-2"
                          >
                            <!-- Options -->
                            <select id="name"
                                    v-model="$v.examenCardioForm.nom.$model"
                                    class="form-control is-invalid retirerBordure"
                                    required
                                    :state="$v.examenCardioForm.nom.$dirty ? !(errorshasField('nom') || $v.examenCardioForm.nom.$error) : null"
                                    @focus="clearErrorField('nom')"
                            >
                              <option v-for="item in noms" :value="item" :key="item">
                                {{ item }}
                              </option>
                            </select>

                            <b-form-invalid-feedback v-if="$v.examenCardioForm.nom.$error">
                              {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>

                            <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                              {{ getErrorsField('nom') }}
                            </b-form-invalid-feedback>

                          </b-form-group>
                        </b-col>
                        <b-col sm="12">
                          <span  class="obligatoire">*</span>
                          <b-form-group
                              id="date-group"
                              :label="$t('message.startDate')"
                              label-for="date"
                          >
                            <b-form-input
                                id="date"
                                v-model="$v.examenCardioForm.date.$model"
                                :state="$v.examenCardioForm.date.$dirty ? !(errorshasField('date') || $v.examenCardioForm.date.$error) : null"
                                type="date"
                                required
                                @click="clearErrorField('date')"
                            ></b-form-input>

                            <b-form-invalid-feedback v-if="$v.examenCardioForm.date.$error">
                              {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                            <span v-if="errorshasField('date')" style="color:red">
                                    {{getErrorsField('date')}}
                                    </span>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12">
                          <span  class="obligatoire">*</span>

                          <b-form-group
                              id="description-group"
                              :label="$t('message.description')"
                              label-for="description"
                          >
                            <b-form-textarea
                                id="description"
                                v-model="$v.examenCardioForm.description.$model"
                                :state="$v.examenCardioForm.description.$dirty ? !(errorshasField('description') || $v.examenCardioForm.description.$error) : null"
                                required
                                @focus="errorshasField('description')"
                            ></b-form-textarea>
                            <b-form-invalid-feedback v-if="!$v.examenCardioForm.description.required">
                              {{ $t('message.requiredField') }}
                            </b-form-invalid-feedback>
                            <b-form-invalid-feedback v-if="!$v.examenCardioForm.description.minLength">
                              {{ $t('message.minCharacters', { n: 3 }) }}
                            </b-form-invalid-feedback>
                            <b-form-invalid-feedback v-if="errorshasField('description')">
                              {{ getErrorsField('description') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <b-col sm="1">
                        </b-col>
                      </b-row>
                      <b-row class="justify-content-sm-center mb-2" v-if="can">
                        <b-button @click="onExamenCardioSubmit" variant="primary">
                          {{ $t('message.save') }}
                        </b-button>
                        <!--                                                <a href="#retourConsultation" class="pt-2"> <i class="fas fa-angle-double-up"></i>  {{$t('message.back')}}</a>-->

                      </b-row>
                    </b-container>
                  </b-form>
                </div>
              </div>
            </div>

            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="conclusions-group"
                    :label="$t('message.conclusion')"
                    label-for="conclusions"
                >
                  <editor
                      :api-key="tinyKey"
                      id="conclusions"
                      v-model="$v.form.conclusions.$model"
                      :state="$v.form.conclusions.$dirty ? !(errorshasField('conclusions') || $v.form.conclusions.$error) : null"
                      @focus="clearErrorField('conclusions')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>

                  <!--                                    <b-form-textarea-->
                  <!--                                            id="conclusions"-->
                  <!--                                            v-model="$v.form.conclusions.$model"-->
                  <!--                                            :state="$v.form.conclusions.$dirty ? !(errorshasField('conclusions') || $v.form.conclusions.$error) : null"-->
                  <!--                                            rows="5"-->
                  <!--                                            @focus="clearErrorField('conclusions')"-->
                  <!--                                    ></b-form-textarea>-->

                  <b-form-invalid-feedback v-if="errorshasField('conclusions')">
                    {{ getErrorsField('conclusions') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group
                    id="traitement-propose-group"
                    :label="$t('message.suggestTreatment')"
                    label-for="traitement-propose"
                >
                  <editor
                      :api-key="tinyKey"
                      id="traitement-propose"
                      v-model="$v.form.traitement_propose.$model"
                      :state="$v.form.traitement_propose.$dirty ? !(errorshasField('traitement_propose') || $v.form.traitement_propose.$error) : null"
                      @focus="clearErrorField('traitement_propose')"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>
                  <!--                                    <b-form-textarea-->
                  <!--                                            id="traitement-propose"-->
                  <!--                                            v-model="$v.form.traitement_propose.$model"-->
                  <!--                                            :state="$v.form.traitement_propose.$dirty ? !(errorshasField('traitement_propose') || $v.form.traitement_propose.$error) : null"-->
                  <!--                                            rows="5"-->
                  <!--                                            @focus="clearErrorField('traitement_propose')"-->
                  <!--                                    ></b-form-textarea>-->

                  <b-form-invalid-feedback v-if="errorshasField('traitement_propose')">
                    {{ getErrorsField('traitement_propose') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="8">
                <b-form-group
                    id="upload-group"
                    :label="$t('message.uploadFile')"
                    label-for="upload"
                >
                  <b-form-file multiple
                               type="file"
                               accept=".jpeg, .png, .gif, .pdf, .docx"
                               ref="file_input"
                               id="upload"
                               :state="$v.form.documents.$dirty ? !$v.form.documents.$error : null"
                               :placeholder="$t('message.uploadFile')"
                  >
                    <template slot="file-name" slot-scope="{ names }">
                      <b-badge variant="dark">{{ names[0] }}</b-badge>
                      <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                        + {{ names.length - 1 }} More documents
                      </b-badge>
                    </template>
                  </b-form-file>
                  <span style="color: red" v-if="errorshasField('documents')">
                                        {{ getErrorsField('documents') }}
                                    </span>

                  <span style="color: red" v-if="maxFileSize.length>0" >{{ maxFileSize }}</span>

                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                    id="u"
                    label="."
                    label-for="upload"
                >
                  <b-button @click="cleardocuments">{{ $t('message.emptyUpload') }}</b-button>
                </b-form-group>
              </b-col>

              <b-col sm="12">

                <b-form-group
                    id="rendez-group"
                    :label="$t('message.appointmentDate')"
                    label-for="consultation"
                    description="">
                  <vue-ctk-date-time-picker class="border-dark" v-model="$v.form.rendez_vous.$model"></vue-ctk-date-time-picker>

                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group
                    id="traitement-appointmentReason-group"
                    :label="$t('message.appointmentReason')"
                    label-for="appointmentReason"
                >
                  <editor
                      :api-key="tinyKey"
                      id="appointmentReason"
                      v-model="$v.form.motifRdv.$model"
                      :init="{
                                              height: 200,
                                              menubar: false,
                                              plugins: plugins,
                                              toolbar:toolbar
                                            }"
                  >
                  </editor>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="justify-content-sm-center">
              <b-button @click="onSubmit" variant="primary" v-if="can">
                {{ $t('message.save') }}
              </b-button>
            </b-row>
          </b-container>
        </b-form>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required,minLength } from 'vuelidate/lib/validators';
import _ from 'lodash';
import SlimSelect from 'slim-select';
import moment from 'moment';
import $ from 'jquery';
import Editor from '@tinymce/tinymce-vue';
import AppConfig from "../../../constants/AppConfig";
import Vue from "vue";

export default {
  name: "AddCardiology",

  components: {
    editor: Editor
  },

  computed: {
    ...mapGetters([
      "practitioners",
      "controlDoctors",
      "file",
      "reasons",
      "allergies",
      "institutions",
      "userInstitutions",
      "errors",
      'hasAdminRole',
      'hasMedecinControleRole',
      'hasAssistante',
      'hasPraticienRole',
       'Timelines']),

    mMedicalFile: function () {
      return (_.isUndefined(this.file) || _.isNull(this.file)) ? [] : this.file;
    },

    mInstitutions: function () {
      let iArray = [];

      _.forEach(_.orderBy(this.userInstitutions, ['created_at'], ['desc']), function (institution) {
        let i = {};

        i.nom = institution.name;
        i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
        i.date = moment(institution.created_at).format('DD-MM-YYYY');
        i.id = institution.id;
        i.slug = institution.slug;

        iArray.push(i);
      });

      return iArray;
    },

    mReasons: function () {
      let rArray = [];

      if (!_.isUndefined(this.reasons)) {
        _.forEach(this.reasons, function (reason) {
          rArray.push({text: reason.description, value: reason.id})
        })
        return rArray;
      }
      return rArray;
    },

    descriptions: function () {
      let aArray = [];

      if (!_.isUndefined(this.allergies)) {
        _.forEach(this.allergies, function (allergy) {
          aArray.push({text: allergy.description, value: allergy.id})
        })
        return aArray;
      }
      return aArray;
    },

    can: function () {
      if (this.hasAdminRole) {
        return true;
      } else {
        return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
      }
    },
    lignetempsRows: function () {
            let self = this;
            let mArray = [];
            _.forEach(_.orderBy(self.Timelines, ['created_at'], ['desc']), function (timelines) {
                let motifs = "";
                let ids = "";

                if (timelines.hasOwnProperty('motif')) {

                    motifs = timelines.motif.description;
                    // ligne_de_temps_id = timelines.id;
                    // console.log('ligne_de_temps_id', ligne_de_temps_id);

                    if (motifs.length > 105) {
                        motifs = timelines.motif.description.substring(0, 105) + " ...";
                    }
                }
                mArray.push({
                    id: timelines.id,
                    date: timelines.date_consultation,
                    motif: motifs,
                    etat: timelines.etat == null ? true : false,
                });
            });
            let sArray = mArray;
            mArray = self.filterResult(sArray, mArray);
            return mArray;
        },

    today: function () {
      return moment((new Date())).format('YYYY-MM-DD');
    },

    mAllergies: function () {
      return (typeof this.mMedicalFile.allergies == "object" ? this.mMedicalFile.allergies : []);
    },

    mAntecedents: function () {
      let mArray = (typeof this.mMedicalFile.antecedents == "object" ? this.mMedicalFile.antecedents : []);

      let cMedecines = this.mMedicalFile.consultations_medecine;
      let cCardiologies = this.mMedicalFile.cardiologies;

      _.forEach(cCardiologies, function(cardiologie){
        if (!_.isNull(cardiologie.conclusion) && cardiologie.conclusion !=='null'){
          let c = {}
          c.type = 'Consultation';
          c.description = cardiologie.conclusion;
          c.date = moment(cardiologie.updated_at).format('YYYY-MM-DD');
          mArray.unshift(c);
        }
      });

      _.forEach(cMedecines, function (medecine){
        _.forEach(medecine.conclusions, function(conclusion){
          let m = {};
          m.type = 'Consultation';
          m.description = conclusion.description;
          m.date = moment(conclusion.updated_at).format('YYYY-MM-DD')
          mArray.unshift(m);
        })
      })

      mArray = _.orderBy(mArray,['date'],['asc']);

      return mArray;
    },

    allergiesRows: function () {
      let aArray = [];

      _.forEach(_.orderBy(this.mAllergies, ['created_at'], ['desc']), function (allergy) {
        aArray.push({description: allergy.description, slug: allergy.slug})
      })

      return aArray;
    },

    antecedentsRows: function () {

      return _.chain(_.orderBy(this.mAntecedents, ['created_at'], ['desc']))
          .groupBy("type")
          .map((value, key) => ({mode: "span", label: key, html: false, children: value}))
          .value();

    },

    mPractitioners: function() {
      let pArray = [];

      _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
        let p = {};
        if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) ){
          let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
          prenom =  prenom.toLowerCase();
          p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          p.id = practitioner.user.id;
          if (p.nom.length >0){
            pArray.push(p);
          }
        }

      });

      return pArray;
    },

    mDoctors: function() {
      let dArray = [];

      _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
        let d = {};
        if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
          let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
          prenom =  prenom.toLowerCase();
          d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
          d.id = doctor.user.id;

          if (d.nom.length >0){
            dArray.push(d);
          }
        }

      });

      return dArray;
    },

    mContributors:function () {
      let cArray = [];
      return cArray.concat(this.mDoctors,this.mPractitioners);
    }
  },

  data(){
    return {
      ligne_de_temps_id: [],
      cardioExams:[],
      noms:[
        "Echographie trans-thoracique",
        "Echographie trans-œsophagienne",
        "Épreuves d'effort",
        "RX Thorax",
        "Electrocardiographie",
        "Echographie",
        "MAPA",
        "Holter",
        "Tilt test",
        "Biologie",
      ],
      facteurs:[
        "Age",
        'Sexe',
        'Hérédité',
        'Tabagisme',
        'HTA',
        'Diabète',
        'Hypercholestérolémie',
        'Excès de poids',
        'Stress',
        'Ménopause',
      ],
      maxFileSize:'',
      tinyKey: AppConfig.tinyMceKey,
      plugins: [
        'advlist autolink lists  image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table'
      ],
      toolbar: 'undo redo | formatselect | bold italic | \
                           alignleft aligncenter alignright | \
                           bullist numlist outdent indent | help',
      afficherAllergie: false,
      afficherAntecedent: false,
      file_id: this.$route.params.file,
      hasChild: false,
      smoke: false,
      drink: false,
      allergiesColumns: [
        {
          label: 'Description',
          field: 'description',
        },
        // {
        //     label: this.$i18n.t('message.startDate'),
        //     field: 'date',
        //     type: 'date',
        //     dateInputFormat: 'yyyy-MM-dd',
        //     dateOutputFormat: 'dd/MM/yyyy',
        // },
      ],

      antecedentsColumns: [
        {
          label: this.$i18n.tc('message.types', 1),
          field: 'type',
        },
        {
          label: 'Description',
          field: 'description',
          html:true
        },
        {
          label: this.$i18n.t('message.startDate'),
          field: 'date',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'dd/MM/yyyy',
        },
      ],

      paginationOptions: {
        enabled: true,
        mode: 'records',
        perPageDropdown: [3, 6, 10]
      },

      enabled: {enabled: true},

      sort: {
        enabled: true,
        initialSortBy: {field: 'date', type: 'desc'}
      },

      form: {
        perimetre_abdominal:'',
        documents:[],
        facteur_de_risque:[],
        motifs: [],
        date_consultation: this.today,
        mode_de_vie: '',
        rendez_vous: null,
        anamese: '',
        examen_clinique: '',
        traitement_propose: '',
        conclusions: '',
        profession: '',
        situation_familiale: 'Celibataire',
        nbre_enfant: '0',
        tabac: '0',
        alcool: '0',
        autres: '',
        contributors: [],
        institution: null,
        poids: '',
        taille: '',
        ta_systolique: '',
        ta_systolique_d: '',
        ta_diastolique: '',
        ta_diastolique_d: '',
        temperature: '',
        frequence_cardiaque: '',
        frequence_respiratoire: '',
        sato2: '',
        traitements: '',
        nbreParJour: 0,
        nbreAnnee: 0,
        motifRdv:null
      },

      examenCardioForm: {
        nom: '',
        description: '',
        date: this.today,
      },

      antecedents: {
        type: '',
        description: '',
        date: this.today,
      },

      allergiesForm: {
        description: [],
        // date:''
      },


      show: true,
      types: [
        {value: 'Médical', text: 'Médical'},
        {value: 'Chirugical', text: 'Chirugical'},
        {value: 'Gynéco-obstétrique', text: 'Gynéco-obstétrique'},
        {value: 'Familial', text: 'Familial'}
      ],
    }
  },

  watch: {
    hasChild: function (oldValue, newValue) {
      if (newValue == false) {
        this.form.nbre_enfant = "0";
      }
    },
    smoke: function (oldValue, newValue) {
      if (newValue == false) {
        this.form.tabac = 0;
      }
    },
    drink: function (oldValue, newValue) {
      if (newValue == false) {
        this.form.alcool = "0";
      }
    },
  },

  methods:{
    getDoctors() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getControlDoctors', { args : args });
    },
    filterResult(sArray, mArray) {
      if (this.filteredValue == 1) {
          mArray = sArray;
      } else if (this.filteredValue == 2) {
          //Non archivés
          mArray = _.filter(mArray, function (medecine) {
              return _.isNull(medecine.archievedAt);
          })
      } else if (this.filteredValue == 3) {
          //Non transmis
          mArray = _.filter(mArray, function (medecine) {
              return _.isNull(medecine.passedAt);
          })
      } else if (this.filteredValue == 4) {
          //Archivés
          mArray = _.filter(mArray, function (medecine) {
              return !_.isNull(medecine.archievedAt);
          })
      } else if (this.filteredValue == 5) {
          //Transmis
          mArray = _.filter(mArray, function (medecine) {
              return !_.isNull(medecine.passedAt);
          })
      }
      return mArray;
    },

    getPractitioners() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getPractitioners', { args : args });
    },

    cleardocuments() {
      this.$refs['file_input'].reset()
    },

    getUserInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getUserInstitutions', {args: args});
    },

    pathTo(element) {
      if (this.$route.fullPath.includes('#')) {
        let position = this.$route.fullPath.search('#');
        return this.$route.fullPath.substr(0, position) + element;
      }
      return this.$route.fullPath + element;
    },

    toggleAntecedent() {
      this.afficherAntecedent = !this.afficherAntecedent;
    },

    toggleAllergie() {
      this.afficherAllergie = !this.afficherAllergie;
    },

    getInstitutions() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getInstitutions', {args: args});
    },

    getAllergies() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getAllergies', {args: args});
    },

    onAntecedentRowClick(params) {
      this.$router.push({name: 'antecedent', params: {antecedent: params.row.slug, file: this.file_id}});
    },

    onAllergieRowClick(params) {
      this.$router.push({name: 'allergy', params: {allergy: params.row.slug}});
    },

    notEmpty(item) {
      return item.length > 0;
    },

    getReasons() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getReasons', {args: args});
    },
    getTimelines() {
        let args = {
            file: this.file_id,
        };
        
        this.$store.dispatch("getTimelines", {
            args
        });
    },

    getMedicalFile() {
      let args = {
        file: this.file_id
      };

      this.$store.dispatch("getMedicalFile", {args});
    },

    onSubmit: function (evt) {
      evt.preventDefault();

      this.$v.form.$touch();

      let files = this.$refs.file_input.selectedFile;
      let nomFichier = "";

      if (!_.isNull(files)){
        _.forEach(files, function (file,key) {
          let taille = (((file.size)/1024)/1024).toFixed(4);
          if (taille > 5){
            nomFichier += key==0 ?'' :','+ file.name + ": "+taille + " Mo";
          }
        });

        if (nomFichier.length>0){
          this.maxFileSize = this.$i18n.t('message.maxFileSize') + nomFichier;
        }else{
          this.maxFileSize = "";
        }
      }
      if (!this.$v.form.$invalid && this.maxFileSize.length ==0) {
        if (!_.isNull(this.form.dateRdv) && this.form.dateRdv != 'Invalid date'){
          this.form.rendez_vous = moment(this.form.rendez_vous).format('YYYY-MM-DD HH:mm');
        }else{
          this.form.rendez_vous = null;
        }
        let formData = new FormData();
        this.form.tabac = (this.form.nbreParJour / 20) * this.form.nbreAnnee;
        formData.append('dossier_medical_id', this.file.id);
        formData.append('ligne_de_temps_id', this.form.ligne_de_temps_id);
        formData.append('nbreCigarette', this.form.nbreParJour);
        formData.append('contributeurs', this.form.contributors);
        formData.append('nbreAnnee', this.form.nbreAnnee);
        formData.append('facteur_de_risque', this.form.facteur_de_risque);
        formData.append('date_consultation', this.form.date_consultation);
        formData.append('mode_de_vie', this.form.mode_de_vie);
        formData.append('anamnese', this.form.anamese);
        formData.append('examen_clinique', this.form.examen_clinique);
        formData.append('rendez_vous', this.form.rendez_vous);
        formData.append('conduite_a_tenir', this.form.traitement_propose);
        formData.append('motifs', this.form.motifs);
        formData.append('conclusion', this.form.conclusions);
        formData.append('profession', this.form.profession);
        formData.append('situation_familiale', this.form.situation_familiale);
        formData.append('nbre_enfant', this.form.nbre_enfant);
        formData.append('tabac', this.form.tabac);
        formData.append('alcool', this.form.alcool);
        formData.append('autres', this.form.autres);
        formData.append('etablissement_id', this.form.institution);
        formData.append('poids', this.form.poids);
        formData.append('taille', this.form.taille);
        formData.append('ta_systolique', this.form.ta_systolique);
        formData.append('ta_systolique_d', this.form.ta_systolique_d);
        formData.append('perimetre_abdominal', this.form.perimetre_abdominal);
        formData.append('ta_diastolique', this.form.ta_diastolique);
        formData.append('ta_diastolique_d', this.form.ta_diastolique_d);
        formData.append('temperature', this.form.temperature);
        formData.append('frequence_cardiaque', this.form.frequence_cardiaque);
        formData.append('frequence_respiratoire', this.form.frequence_respiratoire);
        formData.append('sato2', this.form.sato2);
        formData.append('traitements', this.form.traitements);
        formData.append('motifRdv', this.form.motifRdv);
        _.forEach(this.cardioExams ,function (examen,key) {
          formData.append('examen_cardio['+key+'][nom]', examen.nom);
          formData.append('examen_cardio['+key+'][date_examen]', examen.date_examen);
          formData.append('examen_cardio['+key+'][description]', examen.description);
        });
        // let self= this;
        if (!_.isNull(files)) {
          for (var i = 0; i < this.$refs.file_input.selectedFile.length; i++) {
            let file = this.$refs.file_input.selectedFile[i];
            formData.append('documents[' + i + ']', file);
          }
        }

        let successMessage = this.$i18n.t('message.cardiologyConsultationsCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('createCardiologyConsultation', {args: formData, errorMessages, successMessage})
            .then(() => {
              // Scroll to the top of the page
              document.body.scrollTop = 0; // For Safari
              document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            });
      } else {
        $('html, body').animate({scrollTop: 0}, '300');
      }
    },

    onAllergieSubmit: function (evt) {
      evt.preventDefault();

      this.$v.allergiesForm.$touch();

      if (!this.$v.allergiesForm.$invalid) {
        let args = {
          dossier_medical_id: this.file.id,
          description: this.allergiesForm.description,
          // date: this.allergiesForm.date,
        };

        let successMessage = this.$i18n.t('message.allergyCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('addAllergyVersion', {args, errorMessages, successMessage})
            .then(() => {
              // Scroll to the top of the page
              // document.body.scrollTop = 0; // For Safari
              // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
              this.$v.allergiesForm.description.$model = "";
              this.$v.allergiesForm.$reset();
              // this.$v.allergiesForm.description.$invalid =false;
              // this.$v.allergiesForm.date.$invalid = false;


            });
      }
    },

    onAntecedentSubmit: function (evt) {
      evt.preventDefault();

      this.$v.antecedents.$touch();

      if (!this.$v.antecedents.$invalid) {
        let args = {
          dossier_medical_id: this.file.id,
          type: this.antecedents.type,
          description: this.antecedents.description,
          date: this.antecedents.date
        };

        let successMessage = this.$i18n.t('message.antecedentCreated');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('createAntecedent', {args, errorMessages, successMessage})
            .then(() => {

              // // Scroll to the top of the page
              // document.body.scrollTop = 0; // For Safari
              // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

              this.$v.antecedents.description.$model = '';
              this.$v.antecedents.type.$model = '';
              this.$v.antecedents.date.$model = '';
              this.$v.antecedents.$reset();
            });
      }
    },

    onExamenCardioSubmit:function(evt){
      evt.preventDefault();
      this.$v.examenCardioForm.$touch();
      if (!this.$v.examenCardioForm.$invalid){
        this.cardioExams.push({
          nom:this.examenCardioForm.nom,
          date_examen:this.examenCardioForm.date,
          description:this.examenCardioForm.description,
        });

        this.$v.examenCardioForm.nom.$model="";
        this.$v.examenCardioForm.date.$model="";
        this.$v.examenCardioForm.description.$model="";
        this.$v.examenCardioForm.$reset();

        let self  = this;

        Vue.swal(
            self.$i18n.t('message.cardiacExamAdd'),
            '',
            'success'
        );
      }
    },

    onReset: function (evt) {
      evt.preventDefault();

      // Reset our form values
      this.form.dossier_medical_id = '';
      this.form.date_consultation = '';
      this.form.mode_de_vie = '';
      this.form.anamese = '';
      this.form.examen_clinique = '';
      this.form.traitement_propose = '';
      this.motifs = [''];

      // Trick to reset/clear native browser form validation state
      this.show = false;

      this.$nextTick(() => {
        this.show = true;
      });
    },

    getErrorsField(field) {
      if (this.errorshasField(field)) {
        return this.errors[field][0];
      } else {
        return '';
      }
    },

    errorshasField(field) {
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field) {
      this.$store.dispatch('clearErrorField', {field});

      this.getErrorsField(field);
    }
  },

  validations: {
    form: {
      ligne_de_temps_id: {},
      contributors:{

      },

      facteur_de_risque:{

      },

      motifs: {
        required
      },

      date_consultation: {
        required
      },

      mode_de_vie: {
        //
      },

      anamese: {
        //
      },

      examen_clinique: {
        //
      },

      traitement_propose: {
        //
      },

      conclusions: {
        //
      },

      profession: {

      },

      situation_familiale: {

      },

      nbre_enfant: {

      },

      tabac: {

      },

      nbreParJour: {},

      nbreAnnee: {},

      alcool: {},

      autres: {},

      institution: {
        required
      },

      poids: {},

      perimetre_abdominal: {},

      taille: {},

      ta_systolique: {},

      ta_diastolique: {},

      ta_systolique_d: {},

      ta_diastolique_d: {},

      temperature: {},

      frequence_cardiaque: {},

      frequence_respiratoire: {},

      sato2: {},

      traitements: {},

      rendez_vous: {},
      motifRdv: {},
      documents: {
        // required
      }
    },

    antecedents: {

      type: {
        required
      },

      description: {
        required,
        minLength: minLength(3)
      },

      date: {},
    },

    examenCardioForm: {

      nom: {
        required
      },

      description: {
        required,
        minLength: minLength(3)
      },

      date: {
        required
      },
    },

    allergiesForm: {

      description: {
        required
      },

      date: {},
    },

  },

  mounted() {
    // Fetch control doctor list
    this.getDoctors();

    this.getTimelines();

    // Fetch practitioner list
    this.getPractitioners();

    // Fetch user institution list
    this.getUserInstitutions();

    // Fetch institution list
    this.getInstitutions();
    // Retrieve list of medical documents
    this.getMedicalFile();

    // Fetch reason list
    this.getReasons();

    this.$v.form.date_consultation.$model = this.today;

    var singleMotif = new SlimSelect({
      select: '#singleMotif',
      placeholder: 'Select or add reason',
      addable: function (value) {
        if (singleMotif.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });

    new SlimSelect({
        select: '#timeLine',
        placeholder: 'Select or add timeLine',
        limit: 5
    });

    var allergieSelect = new SlimSelect({
      select: '#allergies',
      placeholder: 'Select or add allergies',
      addable: function (value) {
        if (allergieSelect.selected().length == 5) {
          return false;
        } else {

          // Return the value string
          return value // Optional - value alteration // ex: value.toLowerCase()

        }
      },
      limit: 5

    });

    new SlimSelect({
      select: '#institution',
      placeholder: 'Select institution',
      limit: 1
    });

    new SlimSelect({
      select: '#contributors',
      placeholder: 'Select contributors',
      limit: 5
    });

    new SlimSelect({
      select: '#facteur',
      placeholder: 'Select facteur',
    });

    new SlimSelect({
      select: '#name',
      placeholder: 'Select nom',
      limit:1
    });

    new SlimSelect({
      select: '#type',
      placeholder: 'Select type'
    });

    // Fetch allergy list
    this.getAllergies();

    var btn = $('#button');

    $(window).scroll(function () {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({scrollTop: 0}, '300');
    });

  }

}
</script>

<style scoped>

</style>